import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import FAQ from './FAQ/FAQ';
import More from './More/More';
import Toasts from '@shared/Toasts/Toasts';
import { useSelector } from 'react-redux';
import { childThemeSelector, getUserDataSelector, invitationShownSelector, loadingErrorSelector, versionSelector, } from '@models/user/selectors';
import { useEffect } from 'react';
import InvitationBanner from './InvitationBanner/InvitationBanner';
import Loading from './Loading/Loading';
import ErrorPage from './ErrorPage/ErrorPage';
import { anniversarySelector, isRenewAvailableSelector, myMTSSelector, netariffSelector, prevOwnerSelector, showSubscriptionSelector, } from '@models/subscription/selectors';
import Subscription from './Subscription/Subscription';
import PromoBanner from './PromoBanner/PromoBanner';
import classes from './Main.module.scss';
import VersionButton from '@shared/VersionButton/VersionButton';
import { useWindowSize } from '@hooks/useWindowSize';
import { GTMScreenName } from '@metrics';
import Layout from '@shared/Layout/Layout';
import Additional from './Additional/Additional';
import classNames from 'classnames';
import Partners from './Partners/Partners';
import { dialogSelector } from '@store/models/dialog/selectors';
import { RoleEnum } from '@store/models/subscription/types';
const Main = () => {
    const { isMobile } = useWindowSize();
    const isSubscriptionShown = useSelector(showSubscriptionSelector);
    const { isConnection } = useSelector(getUserDataSelector);
    const isChild = useSelector(childThemeSelector);
    const isMyMTS = useSelector(myMTSSelector);
    const isLoadingError = useSelector(loadingErrorSelector);
    const isInvitation = useSelector(invitationShownSelector);
    const version = useSelector(versionSelector);
    const isNetariff = useSelector(netariffSelector);
    const isAnniversary = useSelector(anniversarySelector);
    const isRenewAvailable = useSelector(isRenewAvailableSelector);
    const isFooterShown = !isMyMTS && !isLoadingError && !isConnection;
    const pageName = isChild ? GTMScreenName.child : GTMScreenName.main;
    const isTariffBlockShown = isSubscriptionShown && !isChild && !isNetariff && !isAnniversary;
    const openedDialog = useSelector(dialogSelector).openedDialog;
    const prevOwner = useSelector(prevOwnerSelector);
    // в окне успешного отключения нужно отобразить стили в зависимости от авторизованного юзера, а не от выбранной темы
    const isParentDisablingDialog = prevOwner !== RoleEnum.Child && openedDialog === 'subscribeDisablingSuccess';
    useEffect(() => {
        if (isChild && !isParentDisablingDialog) {
            document.body.classList.add('child');
            return;
        }
        document.body.classList.remove('child');
    }, [isChild, isParentDisablingDialog]);
    const getBanner = () => {
        if (isInvitation) {
            return _jsx(InvitationBanner, { className: classes.promoBanner });
        }
        if (version === 'child') {
            //Сделано здесь как самое быстрое решение, т.к. при редизайне этот блок в принципе выпилится
            return (_jsx(_Fragment, { children: _jsx(PromoBanner, { className: classes.promoBanner, isPlacementTop: true }) }));
        }
        return _jsx(PromoBanner, { className: classes.promoBanner, isPlacementTop: true });
    };
    const getContent = () => {
        if (isLoadingError) {
            return _jsx(ErrorPage, {});
        }
        if (isConnection) {
            return _jsx(Loading, {});
        }
        // показываем карточку подписки, если она есть, даже если перешел по приглашению
        return (_jsxs("main", { className: classes.main, children: [_jsxs("div", { className: classes.promo, "data-testid": "promo", children: [_jsx("div", { className: classNames({ [classes.childBanner]: isChild }), children: isSubscriptionShown ? _jsx(Subscription, { className: classes.subscription }) : getBanner() }), isMobile && _jsx(VersionButton, { className: classes.versionButton, full: true })] }), _jsx(Partners, {}), _jsx(More, {}), _jsx(Additional, {}), _jsx(FAQ, {})] }));
    };
    return (_jsxs(Layout, { className: classes.wrapper, pageName: pageName, withFooter: isFooterShown, testID: "main", children: [getContent(), _jsx(Toasts, {})] }));
};
export default Main;
